import { useQuery } from '@tanstack/react-query';

import { api, getQueryProps, isTruthy } from 'common';

export function useFlowRunByIdBasic(flowRunId: string) {
  return useQuery({
    ...getQueryProps(api.client.FlowRun, 'findOneByIdBasic', flowRunId),
    enabled: isTruthy(flowRunId),
    retry: 0,
  });
}
